import { useCallback, useEffect, useState } from 'react';

const THEME_KEY = 'ui-theme';

export function readStoredTheme() {
  try {
    const v = window.localStorage.getItem(THEME_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    // Storage blocked: fall through to the device preference.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
}

export function useTheme() {
  const [theme, setTheme] = useState(readStoredTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try {
        window.localStorage.setItem(THEME_KEY, next);
      } catch {
        // Preference just won't persist if storage is blocked.
      }
      return next;
    });
  }, []);

  return { theme, toggle };
}

/** Accent hue per role, mirrored by `:root[data-accent]` in index.css. */
export function accentForRole(role) {
  if (role === 'bidder') return 'indigo';
  if (role === 'caller') return 'teal';
  return 'violet';
}
